import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory, useLocation } from "react-router-dom"
import FormTicketCreate from "./components/FormTicketNew"

const CreationTicket = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const goBack = () => {
    history.goBack()
  }
  const [isMobile, setIsMobile] = useState(
    window.matchMedia("(max-width: 1023px)").matches
  )
  const location = useLocation()
  const [imageData, setImageData] = useState(location?.state?.mobileCamera_b64)

  return (
    <FormTicketCreate
      data={history.location.state?.ticket}
      isNew={Boolean(!history.location.state?.ticket)}
      t={t}
      goBack={goBack}
      isMobile={isMobile}
      setIsMobile={setIsMobile}
      imageData={imageData}
      setImageData={setImageData}
    />
  )
}

export default CreationTicket
